/**
 * An offer waiting for its answer (backend harness/offers, docs/OFFERTE/PIANO.md): one tap takes it, by the button
 * the backend named, as any touch. Agnostic: the words and the button are the backend's, the domain's is nothing here.
 * Gone as soon as the offer is answered or let go: the session then carries none.
 */
import { useApp } from '../../react/app';
import { useSession } from '../../react/hooks';
import { Icon } from '../../ui-kit/Icon';
import css from './Content.module.css';

export function OfferPill() {
  const offer = useSession((s) => s?.offer ?? null);
  const app = useApp();
  if (!offer?.text || !offer.button) return null;
  const { button, data } = offer;
  return (
    <button type="button" className={css.offer} data-offer={offer.id} disabled={app.kiosk.role === 'replay'}
      onClick={() => {
        app.voice?.unlockAudio();
        void app.kiosk.press(button, data);
      }}>
      <Icon name="class" size={28} />
      <span>{offer.text}</span>
    </button>
  );
}
